module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMBAMAAACtsOGuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTLe/x7rBybi/yLrCyrvBybnBybrByrnAybrBybe/x7rByYZY7wMAAAALdFJOUwAg31l/73DPqJBApaoTcgAAADFJREFUCNdjSGEAgmxFIMGsZAAkhbaABLzBAhFAggtEzC5kYBDfCRQJBSrxBnIYQNoAvHUGuYYlTXoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 0